import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { noop } from 'lodash-es';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

import './style-link.scss';

export function StyleLink({ style, onClick = noop }) {
  const { styleName, baseMSRP } = style;

  function clickHandler() {
    onClick(style);
  }

  return (
    <Button
      color="link"
      size="lg"
      className="style-btn text-primary-darker p-0 mt-1"
      onClick={clickHandler}
      data-tracking-id="comparator_select_other_style"
    >
      {styleName}
      <span className="fw-normal"> / {baseMSRP ? formatPriceString(baseMSRP) : 'N/A'}</span>
    </Button>
  );
}

StyleLink.propTypes = {
  style: PropTypes.shape({
    styleName: PropTypes.string,
    baseMSRP: PropTypes.number,
    styleId: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func,
};
